
const oidcAuth = {
  dev: {
    authority: process.env.REACT_APP_AUTHORITY,
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirectSignIn: "http://localhost:3000,https://ui.dev.codes.coke.com",
    redirectSignOut: "http://localhost:3000,https://ui.dev.codes.coke.com"
  }
}

export default oidcAuth;
